export const getSseRefreshOptions = (fallbackInterval: number, mode = import.meta.env.MODE) => ({
  // DPIN production has working SSE; other modes keep polling for sandbox compatibility.
  refetchInterval: mode === 'dpin-bsc' ? (false as const) : fallbackInterval,
});
